<div class="w-full">
    <h1 class="font-bold text-xl md:text-3xl">Agregar Rol</h1>
    <hr class="my-2">
    <mat-form-field class="w-full fuse-mat-dense">
        <mat-label>Nombre de rol</mat-label>
        <input matInput type="string" id="nombreRol" name="nombreRol"
            [(ngModel)]="nombreRol" required/>
    </mat-form-field>

    <div class="w-full flex justify-center md:justify-end gap-3 mt-3">
        <button mat-button mat-raised-button
            class="rounded-sm"  
            [color]="'secondary'" 
            (click)="this.dialogRef.close(false)">
            Cancelar
        </button>

        <button mat-raised-button
            [color]="'primary'" 
            class="rounded-sm"
            type="submit"
            (click)="guardarRol(nombreRol)"
            [disabled]="!nombreRol">Guardar Rol
        </button>
    </div>
</div>